import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default function TrendChart({ items = [], granularity = "daily" }) {
  const fmt = (k) => {
    const d = new Date(k);
    if (granularity === "monthly") return d.toLocaleDateString("en-US", { month: "short", year: "2-digit" });
    if (granularity === "weekly") return `W ${d.toLocaleDateString("en-US", { month: "short", day: "numeric" })}`;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };
  const data = items.map((i) => ({
    key: fmt(i.key),
    "Failure Events": i.events,
    "Downtime (Minutes)": Math.round(i.downtime_min),
  }));

  return (
    <ResponsiveContainer width="100%" height={240}>
      <LineChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
        <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="key" tick={{ fontSize: 10, fill: "#64748b" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} interval="preserveStartEnd" />
        <YAxis yAxisId="left" tick={{ fontSize: 10, fill: "#64748b" }} axisLine={false} tickLine={false} />
        <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 10, fill: "#64748b" }} axisLine={false} tickLine={false} />
        <Tooltip contentStyle={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12 }} />
        <Legend wrapperStyle={{ fontSize: 11 }} iconType="circle" />
        <Line yAxisId="left" type="monotone" dataKey="Failure Events" stroke="#1e40af" strokeWidth={2.5} dot={{ r: 3, fill: "#1e40af" }} />
        <Line yAxisId="right" type="monotone" dataKey="Downtime (Minutes)" stroke="#22c55e" strokeWidth={2.5} dot={{ r: 3, fill: "#22c55e" }} />
      </LineChart>
    </ResponsiveContainer>
  );
}
